import { render } from "./SubscriptionsWidget.vue?vue&type=template&id=07ff411d"
import script from "./SubscriptionsWidget.vue?vue&type=script&lang=js"
export * from "./SubscriptionsWidget.vue?vue&type=script&lang=js"

import "./SubscriptionsWidget.vue?vue&type=style&index=0&id=07ff411d&lang=css"

import exportComponent from "/var/www/service/service-cp-company/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__